<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="盘号">
          <a-select
            showSearch
            allowClear
            :filterOption="filterOption"
            placeholder="请选择盘号"
            v-decorator="[ 'appSsid', validatorRules.appSsid]">
            <a-select-option v-for="item in appList" :value="item.appssid" :key="item.appssid">{{ item.appName }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="版本号">
          <a-input placeholder="请输入版本号" :maxLength="32" v-decorator="[ 'version', validatorRules.version]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="渠道">
          <a-input placeholder="请输入渠道" :maxLength="32" v-decorator="[ 'channel', validatorRules.channel]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="第三方">
          <a-select
            showSearch
            allowClear
            :filterOption="filterOption"
            placeholder="请选择第三方"
            v-decorator="[ 'thirdParty', validatorRules.thirdParty]">
            <a-select-option v-for="item in thirdList" :value="item.thirdParty" :key="item.id">{{ item.thirdName || item.thirdParty }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="动作">
          <a-select
            allowClear
            placeholder="请选择动作"
            v-decorator="[ 'action', validatorRules.action]">
            <a-select-option v-for="item in actionList" :value="item.itemValue" :key="item.itemValue">{{ item.itemText }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="允许跳过">
          <a-switch v-decorator="[ 'allowSkip', { valuePropName: 'checked' }]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="远程跳过">
          <a-switch v-decorator="[ 'remoteSkip', { valuePropName: 'checked' }]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="超过次数跳过">
          <a-input-number :min="0" v-decorator="[ 'timesSkip', validatorRules.timesSkip]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="分数">
          <a-input-number :precision="2" :min="0.00" :max="99.99" v-decorator="[ 'score', validatorRules.score]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="状态">
          <a-select v-decorator="[ 'status', validatorRules.status]" :disabled="isGlobalRow">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">冻结</a-select-option>
          </a-select>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { getThirdAll, addThirdSkip, editThirdSkip } from '@/webpublicapi/third'
import { getDictList } from '@/webpublicapi/dict'
import { getApplistExcludingSubApp } from '@/webpublicapi/order'

export default {
  name: 'ThirdSkipModal',
  data () {
    return {
      title: '操作',
      visible: false,
      model: {},
      // app_ssid='0'(全盘号兜底)的全局行：状态恒为启用，不允许编辑
      isGlobalRow: false,
      appList: [],
      thirdList: [],
      actionList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        appSsid: { rules: [{ required: true, message: '请选择盘号!' }] },
        version: { rules: [{ required: true, message: '请输入版本号!' }] },
        channel: { rules: [{ required: true, message: '请输入渠道!' }] },
        thirdParty: { rules: [{ required: true, message: '请选择第三方!' }] },
        action: { rules: [{ required: true, message: '请选择动作!' }] },
        timesSkip: { initialValue: 0 },
        score: {
          rules: [
            {
              validator: (rule, value, callback) => {
                // 分数可空(留空落0)；填写时必须大于0且小于100
                if (value === null || value === undefined) {
                  callback()
                } else if (value < 0 || value >= 100) {
                  callback('分数必须大于等于0且小于100')
                } else {
                  callback()
                }
              }
            }
          ]
        },
        status: { rules: [{ required: true, message: '请选择状态!' }], initialValue: 1 }
      }
    }
  },
  created () {
    this.loadAppList()
    this.loadThirdList()
    this.loadActionList()
  },
  methods: {
    loadAppList () {
      getApplistExcludingSubApp().then(res => {
        if (res.code === 1000) {
          // 过滤"全部"空值项，避免把空串写进 app_ssid
          this.appList = (res.data || []).filter(item => item.appssid !== '')
        }
      })
    },
    loadThirdList () {
      getThirdAll().then(res => {
        if (res.code === 1000) {
          this.thirdList = res.data
        }
      })
    },
    loadActionList () {
      getDictList().then(res => {
        if (res.code === 1000 && res.data.third_action) {
          this.actionList = res.data.third_action
        }
      })
    },
    filterOption (inputValue, option) {
      return option.componentOptions.children[0].text.indexOf(inputValue) >= 0
    },
    add () {
      this.edit({})
    },
    edit (record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.isGlobalRow = this.model.appSsid === '0'
      // 全局行状态强制回填启用，提交时也恒为 1
      if (this.isGlobalRow) {
        this.model.status = 1
      }
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick({
          ...this.model,
          allowSkip: this.model.allowSkip === 1,
          remoteSkip: this.model.remoteSkip === 1
        }, 'appSsid', 'version', 'channel', 'thirdParty', 'action', 'allowSkip', 'remoteSkip', 'timesSkip', 'score', 'status'))
      })
    },
    // 确定
    handleOk () {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          values.version = (values.version || '').trim()
          values.channel = (values.channel || '').trim()
          values.allowSkip = values.allowSkip ? 1 : 0
          values.remoteSkip = values.remoteSkip ? 1 : 0
          values.timesSkip = values.timesSkip || 0
          values.score = values.score || 0
          const formData = Object.assign(this.model, values)
          let obj
          if (!this.model.id) {
            obj = addThirdSkip(formData)
          } else {
            obj = editThirdSkip(formData)
          }
          obj.then((res) => {
            if (res.code === 1000) {
              that.$message.success(res.msg)
              that.$emit('ok')
            } else {
              that.$message.warning(res.msg)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    // 关闭
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
